module.exports = __webpack_public_path__ + "img/psntest.e2b748a9.svg";